module.exports = __webpack_public_path__ + "static/media/steamy-scoops.dd8d48da.png";